import ssoImg1 from "./../../../../assets/images/Services.jpg"; // Adjust the path as necessary


function StevedoringTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        MOSR{" "}
        <span className="text-orange-ef3e33 font-400"> Stevedores </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4 g-lg-5">
        {/* <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-lg">
          <div className="">
            {/* <p className="mb-4 font-18 font-900">
           ​​​Boating - Safety Surveys
          </p> */}

            <p className="mb-4">
              What is stevedoring: Stevedoring is the process of loading and unloading cargo onto and from ships at ports. Stevedores handle various types of cargo, including containers, bulk materials, and heavy equipment (project cargo). The industry has seen various changes over the years with one of the major changes being containerisation which began in the 1950s and reached South Africa in the 1970s. Prior to containerisation cargo was being transported by bulk cargo vessels and manually picked from cargo holds onto the quayside. This involved a large number of stevedores with the numbers reaching 100s. Containerisation brought about changes which included job losses as cargo was now lifted by a crane from the cargo hold or deck onto the quayside. The risk profile of stevedoring also changed as now operations involved suspended loads. Stevedoring is regarded as one of the dangerous occupations as it involves a lot of moving parts and suspended loads.
            </p>

          </div><div className="col-lg">
            <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
          </div> <br />
          <p className="mb-4 font-18 font-900">
            MOSR compliance regime
          </p>
          <p className="mb-4">
            Management of the compliance regime for stevedoring operations falls within SAMSA’s OHS & Maritime Welfare Unit. The Unit comprise of specialists in the field of Occupational Health and Safety. The Unit execute its mandate through the following activities.
          </p>
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >Stevedore MOSR safety inspections
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">Stevedore inspections are conducted nationally in all the ports and applicable harbours. These are unannounced inspections involving observation of stevedore operations for unsafe acts and conditions, inspection of personal protective equipment, as well as inspection of mobile equipment, lifting gear and lifting plant. The inspections also involve inspection of safety documentations i.e. daily occupational safety inspection checklist, toolbox talk, crane inspection checklist, register of lifting appliances and loose gear etc.</p>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button "
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="true"
                  aria-controls="blackTabTwo"
                >Stevedore company audits
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                    Stevedore companies are audited biennially. The audit takes place at the company’s premises and companies are audited only for work on board vessels. The audit involves safety management documentation review i.e. baseline risk assessment, safe work procedures, training records etc, including auditing of machinery, mobile equipment and lifting gear that is used in stevedoring operations.
                  </p>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >Stevedore safety/stakeholders committee meetings
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                    The meetings are held biennially. The meetings have played an important role in the management of the MOSR compliance regime as it kept SAMSA up to date with issues that are taking place in various ports. During the meetings stevedores are able to sit down together and discuss safety related issues, incidents and compliance challenges. SAMSA shares casualty statistics, safety observations from the inspections around the country as well as common audit findings. The meetings are attended by all stevedore companies in a particular port, Transnet National Port Authority (TNPA), Transnet Port Terminals (TPT) and from time-to-time other relevant entities are invited to present at the meetings.  The stevedore safety/stakeholders committee meetings have been established in these ports:
                  </p>
                  <p className="mb-3">i.	Richards Bay
                  </p>
                  <p className="mb-3">ii.	Durban
                  </p>
                  <p className="mb-3">iii.	Ngqura and Port Elizabeth
                  </p>
                  <p className="mb-3">iv.	Cape Town
                  </p>
                  <p className="mb-3">v.	Saldanha Bay
                  </p>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabFour"
                  aria-expanded="false"
                  aria-controls="blackTabFour"
                >MOSR Awareness campaigns
                </button>
              </h2>
              <div
                id="blackTabFour"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                    The campaigns were established in 2018 after a decade high of 11 incidents including 2 fatalities. The awareness campaign initially focused on stevedore foreman as SAMSA had noted that lack of supervision had contributed to many of the incidents. The awareness campaigns involve awareness of the MOSR, its application including its practical application. SAMSA conducts awareness campaigns at the invitation of companies, new companies as well as companies with challenges when it comes to compliance or experiences high number of casualties. SAMSA has produced a Stevedore safety video to provide awareness on MOSR compliance requirements as well as provide a broad awareness of hazards and risks associated with stevedoring. The videos main target were the smaller companies which did not have the resources to produce comprehensive induction resources. The videos are produced in English, isiZulu, IsiXhosa and Afrikaans. The video can be utilised by stevedore companies for induction training. The stevedore video is broad as such each company is to use it to supplement its own induction programme which will cover items specific to their operations. The video can be found in this portal under resources.
                  </p>

                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackFive"
                  aria-expanded="false"
                  aria-controls="blackTabFive"
                >Casualty investigations
                </button>
              </h2>
              <div
                id="blackTabFive"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab">
                <div className="accordion-body">
                  <p className="mb-3">
                    SAMSA conducts casualty investigations for incidents involving stevedores. The main purpose of the investigations is to establish the root cause of the incidents and to prevent future occurrences.  Casualties occurring onboard a ship are reported to SAMSA using official forms obtainable from SAMSA local offices and this website under the Forms section.
                  </p>
                </div>
              </div>
            </div>
            <p className="mb-4">
              To report any stevedore safety related concerns, kindly communicate with SAMSA via the SAMSA contact form or email <a href="mailto:nmjweni@samsa.org.za">nmjweni@samsa.org.za</a> or  contact the local SAMSA Office ( The office contact details are provided in this website).
            </p>
          </div>
        </div>

      </div>
    </>
  );
}


export default StevedoringTab